import { render, staticRenderFns } from "./PDPStickyCTA.vue?vue&type=template&id=2270103a&scoped=true"
import script from "./PDPStickyCTA.vue?vue&type=script&lang=js"
export * from "./PDPStickyCTA.vue?vue&type=script&lang=js"
import style0 from "./PDPStickyCTA.vue?vue&type=style&index=0&id=2270103a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2270103a",
  null
  
)

export default component.exports